import { render, staticRenderFns } from "./kaiMusic.vue?vue&type=template&id=72267ea6&scoped=true"
import script from "./kaiMusic.vue?vue&type=script&lang=js"
export * from "./kaiMusic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72267ea6",
  null
  
)

export default component.exports